import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsMobileQrScan: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.86 32h18.28v-1.52h1.53V1.52h-1.53V0H6.86v1.52H5.33v28.96h1.53ZM16 1.52h3.05v1.53H16Zm-3.05 0h1.53v1.53h-1.53ZM6.86 3.05h4.57v1.52h9.14V3.05h4.57v25.9H6.86Z\"/><path fill=\"currentColor\" d=\"M20.57 15.24h1.52v1.52h-1.52Zm-1.52 4.57v1.52h3.04v-3.04h-1.52v1.52zm0-3.05h1.52v1.53h-1.52Zm0-6.09h1.52v3.04h1.52V9.14h-3.04zM16 12.19v3.05h3.05v-1.53h-1.53v-1.52zm0 4.57h1.52v1.53H16Zm-1.52-7.62h3.04v1.53h-3.04Zm0 10.67h3.04v1.52h-3.04Zm-1.53-4.57h1.53v3.05h-1.53Zm0-3.05h1.53v1.52h-1.53Zm-1.52 6.1H9.9v3.04h3.05v-1.52h-1.52zM9.9 15.24h1.53v1.52H9.9Zm1.53-4.57h1.52V9.14H9.9v4.57h1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsMobileQrScan
